module.exports = __webpack_public_path__ + "img/eh.83c9915c.svg";